import { withRouter } from 'next/router'
import { Link } from '~/i18n'

const OrganizationLink = ({
  href, router, children, ...props
}) => {
  if (!href) {
    return children
  }
  return <Link href={`/organizations/${router.query.slug}/${href}`} prefetch={false} {...props}>{children}</Link>
}

export default withRouter(OrganizationLink)
